import { render, staticRenderFns } from "./SimpleImagePicker.vue?vue&type=template&id=44ed584d&"
import script from "./SimpleImagePicker.vue?vue&type=script&lang=js&"
export * from "./SimpleImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./SimpleImagePicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports